import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CourseCatalogueSearchResult } from '../../../course-catalogue/models/course-catalogue-search-result';
import { CurriculumConstants } from '../../constants/curriculum.contants';
import { MenuItem, MessageService } from 'primeng/api';
import { cloneDeep } from 'lodash-es';
import { CurriculumPersistenceService } from '../../services/curriculum-persistence.service';
import { CurriculumService } from '../../services/curriculum.service';
import { CurriculumDetails } from '../../models/curriculumDetails';
import { TrainingItemDetails } from '../../models/trainingItemDetails';
import { Curriculum } from '../../models/curriculum';
import { EqmsScopeManagementService } from '../../../shared/services/eqms-scope-management.service';
import { CourseCatalogueSearchComponent } from '../../../course-catalogue/course-catalogue-search/course-catalogue-search.component';

@Component({
  selector: 'app-curriculum-course-details',
  templateUrl: './curriculum-course-details.component.html',
  styleUrls: ['./curriculum-course-details.component.scss']
})
export class CurriculumCourseDetailsComponent implements OnInit{
  @Output() activateTabIndex = new EventEmitter<number>();
  feature:string = CurriculumConstants.Curriculum_Feature;
  panelListScreen : string = CurriculumConstants.CurriculumCourseDetails;
  courseCatalogueSearchResult: CourseCatalogueSearchResult[] = []
  isCurriculumSaveInProgress: boolean = false;
  curriculumSaveProgressMessage : string = CurriculumConstants.Curriculum_SaveInProgress;
  errorMessages: string[] = [];  
  items: MenuItem[] = [];
  showAddButton : boolean = false;
  selectedCourses : CourseCatalogueSearchResult[] = [];
  showCheckBoxes : boolean = true;
  linkedItemDataToDisplay:any;
  @Input() selectedScope: any = [];
  @Input() eqmsScopeTreeNodes: any = [];
  listOfselectedCourses:string[]=[];
  linkedTrainingItem : any;
  curriculumDetails !: CurriculumDetails;
  scope?:number;
  trainingItemsList : TrainingItemDetails[]=[];
  curriculum !: Curriculum;
  trainingItemNumbers : string[] = [];
  isUpdate: boolean = false;
  addAndClose : boolean = false;
  errorCount : number = 0;
  eqmsScopes:number[] = []
  displayDataCollected : string[] = []
  trainingItemsDataToDisplay : any;

  @ViewChild(CourseCatalogueSearchComponent)
  private courseSearch!: CourseCatalogueSearchComponent;
  
    constructor(
      private messageService : MessageService,
      private curriculumService : CurriculumService,
      private eqmsScopeManagementService: EqmsScopeManagementService,
      private curriculumPersistenceService : CurriculumPersistenceService){
      this.items = [
      {
          label: 'Add',
          command: this.add
      }
    ]
  
    }
    ngOnInit() : void{
      this.curriculumPersistenceService.curriculumSaveInProgress$.
        subscribe((curriculumSaveStatus) => {
          this.isCurriculumSaveInProgress = curriculumSaveStatus;
        });
      this.curriculumPersistenceService.closeAndResetCurriculumSlider$.subscribe((isClose) => {
        if (isClose) { this.closeAndResetCurriculumSlider(); }
      })
    }
  
  
    onSelectionOrDeselection = (courses: CourseCatalogueSearchResult[]) => {

      let selectedCoursesList: string[] = [];
      courses.forEach(element => {
        selectedCoursesList.push(element.courseNumber);
      });
      this.displayDataCollected=[]
      this.displayDataCollected = selectedCoursesList;
      this.selectedCourses = [];
      this.selectedCourses = cloneDeep(courses);
    }
  
    addCurriculumAndClose(){
      this.addAndClose = true;
      this.getLinkedItems(this.addAndClose)
    }
  
    add = () => {
      this.addAndClose = false;
      this.getLinkedItems(this.addAndClose);
    };

    closeAndResetCurriculumSlider(){
      this.selectedCourses = [];
      this.displayDataCollected = [];
      this.courseCatalogueSearchResult = [];
      this.showAddButton = false;
    }
  
    showOrHideAddButton = (displayAddBtn: boolean) => {
      this.showAddButton = displayAddBtn;
    }
  
    getLinkedItems(addAndClose:boolean)
    {
      this.eqmsScopes=[]
      const courseData = Object.assign([], this.selectedCourses);
      this.selectedCourses = courseData.map((course:any) => ({
        number: course.courseNumber,
        title: course.name,
        ...course, 
      }));
      this.errorCount=0;
      this.scope = this.selectedScope.data.eQMSScopeId
         this.curriculumService.getCurriculum(this.scope).subscribe((curriculum)=>{
        this.curriculum = curriculum;
        this.curriculumPersistenceService.updateCurriculumDetails(curriculum);
        if(this.curriculum != null)
        {
          this.isUpdate = true;
        }
        this.validateAndCreateOrUpdateCurriculum(addAndClose);
      });
    }
  
    validateAndCreateOrUpdateCurriculum(addAndClose:boolean){
      if(this.selectedCourses.length<=0)
      {
        this.validateToSelectAtleastOneTrainingItem();
      }
      else{
          if(this.isUpdate){
            this.validateIfTrainingITemIsAlreadySaved(this.selectedCourses);
          }
          else{
            this.validateIfTrainingItemIsAlreadySelected(this.selectedCourses);
          }

           this.getParentScopesAndCompare(this.selectedCourses, this.isUpdate, addAndClose); 
        }
    }
  
    updateCurriculum(matchingCourses: any[],addAndClose : boolean){
        this.curriculumPersistenceService.prepareDataForCourseTrainingItem(matchingCourses,
          this.isUpdate, this.scope);
        this.curriculumPersistenceService.updateCurriculum(addAndClose);
    }
  
    addCurriculum(matchingCourses: any[],addAndClose : boolean){
        this.curriculumPersistenceService.prepareDataForCourseTrainingItem(matchingCourses,this.isUpdate, this.scope);
        this.curriculumPersistenceService.addCurriculum(addAndClose);
    }
  
    validateToSelectAtleastOneTrainingItem(){
      this.errorCount = 0;
      this.messageService.add({
        severity: CurriculumConstants.Severity_Err,
        summary: `${CurriculumConstants.AtleastOneTrainingItem_ShouldBeSelected}`,
        life: 20000
      });
      this.errorCount++; 
    }
  
    validateIfTrainingItemIsAlreadySelected(matchingCourses : any[]){
      var courseNumbers : string[] = [];
      matchingCourses.find(element => {
        if(Object.values(this.listOfselectedCourses.indexOf(element.courseNumber)>=0))
        {
          courseNumbers.push(element.courseNumber);
        }
        else
        {
          this.trainingItemsDataToDisplay.push(element.courseNumber);
        }
        });
        this.displayDataCollected = courseNumbers.filter( x => !this.trainingItemNumbers.find(a=> a==x) );
        this.selectedCourses = this.selectedCourses.filter(x => this.displayDataCollected.find(a=> a == x.courseNumber));
        const sameElements = courseNumbers.filter( x => this.trainingItemNumbers.find(a=> a == x));
        if(sameElements.length > 0){
          this.validationMessageForTrainingItemAlreadyExisting(sameElements);
        }
    }
  
    validateIfTrainingITemIsAlreadySaved(matchingCourses : any[]){
      var courseNumbers : string[] = [];
      this.trainingItemNumbers = [];
      this.curriculum.trainingItems.find(element=>{
        this.trainingItemNumbers.push(element.id);
      })
      matchingCourses.find(element => {
        if(Object.values(this.trainingItemNumbers.indexOf(element.courseNumber)>=0))
        {
          courseNumbers.push(element.courseNumber);
        }
        });
        this.displayDataCollected = courseNumbers.filter( x => !this.trainingItemNumbers.find(a=> a==x) );
        this.selectedCourses = this.selectedCourses.filter(x => this.displayDataCollected.find(a=> a == x.courseNumber));
        const sameElements = courseNumbers.filter( x => this.trainingItemNumbers.find(a=> a == x));
        if(sameElements.length > 0)
        {
          this.validationMessageForTrainingItemAlreadyExisting(sameElements);
        }
    }
  
  
      //since scopes are not matching, we are trying to get its parent scopes and compare with selected form scopes
      getParentScopesAndCompare(serviceData: any[], isUpdate: boolean, addAndClose: boolean) {
        const scopes: any[] = [];
        scopes.push(this.selectedScope.data.eQMSScopeId);
        this.selectedScope.data?.ancestors.forEach((ele : number) => {
          scopes.push(ele);
        }); 
      
        const matchingCourses: any[] = [];
        const mismatchedCourses: any[] = [];
        
        serviceData.forEach((data) => {
          const { eqmsScopes } = data;    
          const hasMatch = eqmsScopes.some((scope: number) => scopes.includes(scope));    
          if (hasMatch) {
            matchingCourses.push(data);
          } else {
            mismatchedCourses.push(data);
          }
        });
        if (mismatchedCourses.length) {
          this.displayScopeValidationMessage(mismatchedCourses);
        }
        if (matchingCourses.length) {
          this.selectedItems(matchingCourses);
          if(!isUpdate){
            this.addCurriculum(matchingCourses,addAndClose);
          }
          else{
            this.updateCurriculum(matchingCourses,addAndClose);
          }
        }
      }

      selectedItems(serviceData : any[]){
        if (!this.trainingItemsDataToDisplay || this.trainingItemsDataToDisplay.length === 0) {
          this.trainingItemsDataToDisplay = serviceData;
        } else {
          this.trainingItemsDataToDisplay.push(...serviceData);
        }
      }
  
      displayScopeValidationMessage(mismatchedCourses: any[]) {
        this.errorCount = 0;
        const courseNumbersString = mismatchedCourses.map((course) => `  ${course.courseNumber}`).join(', ');
        const validationMessage = CurriculumConstants.Selected_CourseScopes_Not_Matching_Error_Message.replace(
          'CourseNumbers',
          `\n${courseNumbersString}`
        );
        this.messageService.add({
          severity: CurriculumConstants.Severity_Err,
          summary: `${validationMessage}`,
          life: 20000
        });
        this.errorCount++; 
      }
  
      validationMessageForTrainingItemAlreadyExisting(mismatchedCourses : any[]){
        this.errorCount = 0;
        const courseNumbersString = mismatchedCourses.map((course) => `  ${course}`).join(', ');
          const validationMessage = CurriculumConstants.LinkedCourse_AlreadyExists_InCurriculum.replace(
            'CourseNumbers',
            `\n${courseNumbersString}`
          );
          this.messageService.add({
            severity: CurriculumConstants.Severity_Err,
            summary: `${validationMessage}`,
            life: 20000 
          });
          this.errorCount++;
        }
}
